import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { UserloginComponent } from './components/userlogin/userlogin.component';
import { UserregisterComponent } from './components/userregister/userregister.component';
import { OrdersComponent } from './components/orders/orders.component';
import { ProfileComponent } from './components/profile/profile.component';
import { MyTaskComponent } from './components/my-task/my-task.component';
import { ForgotComponent } from './components/forgot/forgot.component';
import { SignupComponent } from './components/signup/signup.component';
import { OtpComponent } from './components/otp/otp.component';
import { NewpassComponent } from './components/newpass/newpass.component';
import { SliderComponent } from './components/slider/slider.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CartComponent } from './components/cart/cart.component';
import { NotificationComponent } from './components/notification/notification.component';
import { HowDoesItWorkComponent } from './components/shared/footer/how-does-it-work/how-does-it-work.component';
import { ContactsComponent } from './components/shared/footer/contacts/contacts.component';
import { ResetpasswordComponent } from './components/forgot/resetpassword/resetpassword.component';
import { GlobeComponent } from './globe/globe.component';
import { DisclaimerComponent } from './components/shared/footer/disclaimer/disclaimer.component';
import { PrivacypolicyComponent } from './components/shared/footer/privacypolicy/privacypolicy.component';
import { AcceptableUsePolicyComponent } from './components/shared/footer/acceptableusepolicy/acceptableusepolicy.component';
import { PaypalsuccessComponent } from './components/paypalsuccess/paypalsuccess.component';
import { ErrorComponent } from './components/error/error.component';
import { RequestDemoComponent } from './components/request-demo/request-demo.component';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { DepositsComponent } from './components/deposits/deposits.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SubscribeGuard } from './subscribe.guard';
import { FundAllocationComponent } from './components/fund-allocation/fund-allocation.component';
import { PaymentsuccessComponent } from './components/paypalsuccess/paymentsuccess/paymentsuccess.component';
import { BudgetsComponent } from './components/budgets/budgets.component';
import { LeafletTaskComponent } from './components/leaflet-task/leaflet-task.component';
import { LeafletNewcollectionsComponent } from './components/leaflet-newcollections/leaflet-newcollections.component';
import { QuotesComponent } from './components/quotes/quotes.component';
import { SupportTicketCreateComponent } from './components/support-tickets/support-ticket-create.component';
import { SupportTicketDetailComponent } from './components/support-tickets/support-ticket-detail.component';
import { SupportTicketListComponent } from './components/support-tickets/support-ticket-list.component';
import { WhatsNewComponent } from './components/shared/footer/whats-new/whats-new.component';
import { RoleGuard } from './role.guard';
import { TouGuard } from './components/shared/guards/touguard';
import { WildcardRedirectComponent } from './components/shared/utils/wildcard-redirect-componenet';
import { WildcardGuard } from './components/shared/guards/wild-card-guard';
import { DataPreviewComponent } from './components/shared';
import { TermsOfUseComponent } from './components/shared/footer/terms-of-use/terms-of-use.component';
import { PendingOperationGuard } from './shared/service/pending-operation.guard';
import { ActivityLogComponent } from './components/shared/activity-log/activity-log.component';

const routes: Routes = [
  // basic routes
  {path: '', redirectTo: 'task',  pathMatch: 'full'},
  {
    path: '',
    component: AppLayoutComponent,
    
    children: [
      { path: 'task', component: MyTaskComponent, canActivate: [SubscribeGuard,RoleGuard]},
      { path: 'topbar', component: TopbarComponent, canActivate: [TouGuard] },
      { path: 'collections', component: LeafletNewcollectionsComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard],canDeactivate: [PendingOperationGuard] },
      { path: 'cart', component: CartComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard] },
      { path: 'newtask', component: LeafletTaskComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard] }, 
      { path: 'payment', component: PaymentComponent, canActivate: [SubscribeGuard,TouGuard] },
      { path: 'orders', component: OrdersComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard] },
      { path: 'notification', component: NotificationComponent, canActivate: [SubscribeGuard,TouGuard] },
      { path: 'howitworks', component: HowDoesItWorkComponent, canActivate: [TouGuard]},
      { path: 'disclaimer', component: DisclaimerComponent, canActivate: [TouGuard]},
      { path: 'privacypolicy', component: PrivacypolicyComponent, canActivate: [TouGuard]},
      { path: 'acceptableusepolicy', component: AcceptableUsePolicyComponent, canActivate: [TouGuard]},
      { path: 'requestdemo', component: RequestDemoComponent, canActivate: [TouGuard]},
      { path: 'support', component: ContactsComponent, canActivate: [TouGuard]},
      { path: 'payment-success', component: PaypalsuccessComponent, canActivate: [TouGuard]},
      { path: 'error', component: ErrorComponent, canActivate: [TouGuard]},
      { path: 'deposits', component: DepositsComponent, canActivate: [RoleGuard,TouGuard]},
      { path: 'retask', component: LeafletTaskComponent, canActivate: [SubscribeGuard,RoleGuard] },
      { path: 'deposit', component: SubscriptionComponent,},
      { path: 'allocation', component: FundAllocationComponent},
      { path: 'success', component: PaymentsuccessComponent},
      { path: 'budget', component: BudgetsComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'newbudget', component: LeafletTaskComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard] },
      { path: 'leaflet-task', component: LeafletTaskComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'leaflet-new-collections', component: LeafletNewcollectionsComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'quotes', component: QuotesComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'support-tickets', component: SupportTicketListComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'support-tickets/new', component: SupportTicketCreateComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'support-tickets/:id', component: SupportTicketDetailComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'whats-new', component: WhatsNewComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'users', loadChildren: () => import('./components/users/users.module').then(m => m.UsersModule), canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'sub-accounts', loadChildren: () => import('./components/sub-accounts/sub-accounts.module').then(m => m.SubAccountsModule), canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'preview', component: DataPreviewComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
      { path: 'termsofuse', component: TermsOfUseComponent, canActivate: [TouGuard]},
      { path: 'activity-log', component: ActivityLogComponent, canActivate: [SubscribeGuard,RoleGuard,TouGuard]},
    ],
  },
  // login route
  {
    path: '',
    component: AuthLayoutComponent,

    children: [
      { path: 'login', component: UserloginComponent},
      { path: 'register', component: UserregisterComponent},
      { path: 'forgot', component: ForgotComponent},
      { path: 'resetpassword', component: ResetpasswordComponent},
      { path: 'otp', component: OtpComponent},
      { path: 'newpass', component: SignupComponent}
    ],
  },
  {
    path:'not-found',
    component: NotFoundComponent,
  },

  {
    path: 'slider',
    component: SliderComponent,
  
  },
  {
    path: 'globe',
    component: GlobeComponent,
  
  },

  // redirect to home
  { path: '**', component: WildcardRedirectComponent, canActivate: [WildcardGuard] },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
